import { render, staticRenderFns } from "./steelSidebandFile.vue?vue&type=template&id=a6f5126c&scoped=true"
import script from "./steelSidebandFile.vue?vue&type=script&lang=js"
export * from "./steelSidebandFile.vue?vue&type=script&lang=js"
import style0 from "./steelSidebandFile.vue?vue&type=style&index=0&id=a6f5126c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f5126c",
  null
  
)

export default component.exports